
<div class="background page">
    <div class="inset" [@trigger]=currentState >
      <h1>Apply</h1>
        <h2 *ngIf="!profile || !!profile && !!profile.anonymous" (click)="um.openSignUp()">You'll need to Login Or Register with your email and password in order to continue.</h2>
       <form (ngSubmit)="submitApplication()" *ngIf="!!profile && !profile.anonymous">      
          <h3>Information about the church</h3>
          <mat-form-field mat-error>
            <mat-label>Church Name</mat-label>
            <input 
              matInput 
              id="name" 
              class="short" 
              name="name" 
              type="text" 
              [(ngModel)]="app.name"><br/>
          </mat-form-field>
           <mat-form-field >
          <input matInput
            id="phone"
            class="short"
            name="phone"
            type="tel"
            placeholder="Church Phone Number" [(ngModel)]="app.phone">
          </mat-form-field> 
          <p>*NOTE: THIS SHORT CHURCH NAME WILL BE SEEN BY YOUR STUDENTS. Please do not use anything that would be identifiable with the Seventh-day Adventist Church. In other words, if your church’s name is Main Street Seventh-day Adventist Church, please DO NOT choose a short name like 'mssda'. Instead, choose 'ms01', 'msc7', or something similar. When sharing the link to your church’s online Bible school, the link will be displayed as ‘itiswritten.study/ms01' or similar.</p>
        <mat-form-field> 
          <input
            matInput 
            matTooltip="*NOTE: THIS SHORT CHURCH NAME WILL BE SEEN BY YOUR STUDENTS. Please do not use anything that would be identifiable with the Seventh-day Adventist Church. In other words, if your church’s name is Main Street Seventh-day Adventist Church, please DO NOT choose a short name like 'mssda'. Instead, choose 'ms01', 'msc7', or something similar. When sharing the link to your church’s online Bible school, the link will be displayed as ‘itiswritten.study/ms01' or similar."
            id="code"
            class="short"
            name="code"
            type="text"
            
            [input]="removeSpaces()"

            placeholder="Short Church Name" [(ngModel)]="app.entityId"><br/>
        </mat-form-field> 
        <mat-form-field> 
          <input matInput id="email-church" class="short" name="email-church" type="email" placeholder="Church Email" [(ngModel)]="app.email"><br/>
        </mat-form-field> 
        <mat-form-field> 
          <input matInput id="address" class="short" name="address" type="text" placeholder="Address" [(ngModel)]="app.address"><br/>
        </mat-form-field> 
        

      
      <mat-form-field> 
          <input matInput id="si-city" class="short" name="city" type="text" placeholder="City" [(ngModel)]="app.city"><br/>
      </mat-form-field> 
        <mat-form-field> 
          <input matInput id="si-country" class="short" name="country" type="text" placeholder="Country" [(ngModel)]="app.country"><br/><br/>
        </mat-form-field> 
          
 

      <h3>Pastor's Information</h3>
      <mat-form-field mat-error>
      <input
        matInput 
        *ngIf="!!app?.pastor" 
        id="'pastor'" 
        class="short" 
        name="'pastor'" 
        type="text" 
        placeholder="Name" 
        [(ngModel)]="app.pastor.name"
        >
      </mat-form-field>
      <mat-form-field> 
          <input matInput *ngIf='!!app?.pastor' id="phone" class="short" name="phone" type="tel" placeholder="Telephone" [(ngModel)]="app.pastor.phone"><br/>
      </mat-form-field> 
   <mat-form-field> 
          <input 
            matInput *ngIf='!!app?.pastor' id="email" class="short" name="email" type="email" placeholder="Email " [(ngModel)]="app.pastor.email"><br/>
      </mat-form-field> 
          
            <div class="alert hideMessage" [ngClass]="{showMessage : verificationMessage, hideMessage:!verificationMessage}">
                <span class="closxpebtn" (click)="hideSuccessMessage()">&times;</span> 
                <strong>Sent!</strong> Your message was sent!
              </div>
            <div class="errorAlert hideMessage" [ngClass]="{showMessage : errorMessage, hideMessage:!errorMessage}">
                <span class="closebtn" (click)="hideErrorMessage()">&times;</span> 
                <strong>{{errorMessage}}</strong> 
              </div>
  
          <button class="buttonConfig">Send</button>
          <div style="width: 100%; height: 0; padding-bottom: 50%"></div>
    </form>
    </div>
  </div>